// extracted by mini-css-extract-plugin
export default {"tree":"NRqf3E6srBvZw2gZJTZb","button":"PmnvSlER5xw2brbjHpjW","resourceGroup":"pValhg8dnVeo0aX2AcJI","policy":"Tomk41DPlb63KRT4YMSn","tooltip":"NMHwZNkkXD5gGAtyIyuW"};